export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-700.3ce1d249.ttf";